const GROUP_ORDER = ['configured', 'extra', 'inherited'];

const groupAttributeOptions = (variables = [], preserveValue = '') => {
  const groups = new Map(GROUP_ORDER.map((group) => [group, []]));
  const seen = new Set();

  variables.forEach((variable) => {
    const value = String(variable?.value || '').trim();
    if (!value || seen.has(value)) return;
    seen.add(value);
    const group = groups.has(variable?.group) ? variable.group : 'configured';
    groups.get(group).push({ ...variable, value, group });
  });

  const selected = String(preserveValue || '').trim();
  if (selected && !seen.has(selected)) {
    groups.get('extra').push({
      value: selected,
      label: `${selected} (preservado)`,
      type: '',
      group: 'extra'
    });
  }

  return GROUP_ORDER
    .map((group) => [group, groups.get(group).sort((left, right) => left.value.localeCompare(right.value, 'pt-BR'))])
    .filter(([, options]) => options.length);
};

module.exports = {
  groupAttributeOptions
};
